import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center border-top py-6 px-3" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "max-width" }
const _hoisted_4 = { class: "mt-4 mb-3" }

import errorImg from '@grantstreet/govhub-vue/src/assets/error-page-illustration.svg'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicLoadErrorPage',
  setup(__props) {

/**
 * This component should probably only be used to replace dynamically loaded
 * pages that fail. At time of writing (1) the user is left on the failed url
 * (not redirected), and (2) told they can try reloading. That is usually not
 * the case for other errors which is why this one is separated out.
 */
const i18n = useI18n()


return (_ctx: any,_cache: any) => {
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("img", {
      src: _unref(errorImg),
      alt: _unref(i18n).t('error.dynamicPageLoadError.title'),
      class: "img-fluid"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(i18n).t('error.dynamicPageLoadError.title')), 1),
      _withDirectives(_createElementVNode("p", null, null, 512), [
        [_directive_dompurify_html, _unref(i18n).t('error.dynamicPageLoadError.desc')]
      ])
    ])
  ]))
}
}

})